import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { RememberService } from '../../../core/services/remember.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-select-stock-location',
  templateUrl: './select-stock-location.component.html',
  styleUrls: ['./select-stock-location.component.css']
})
export class SelectStockLocationComponent implements OnInit {
    stockPlaceId;

    public setting?: Setting;

    public selectListStockZones: StockZoneItem[] = [];

    public itemsListStockLocations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService, private rememberService: RememberService) {
        this.stockPlaceId = this.stateService.getStateParams()['stockplace_id'];
    }

    private async loadSetting() {
        if (!!this.stockPlaceId) {
            this.setting = (await this.datatask.Post(942, { stockplace_id: this.stockPlaceId }))[0];
        }
    }

    private async loadStockZones() {
        if (!this.setting) return;

        return this.selectListStockZones = await this.datatask.Post(943, { stockplace_id: this.setting.stockplace_id });
    }

    private async loadStockLocations() {
        if (!this.setting) return;

        return this.itemsListStockLocations = await this.datatask.Post(472, {
            stockzone_keyno: this.setting.stockzone_keyno,
            stockplace_id: this.setting.stockplace_id
        });
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        if (!this.setting) return;

        if (!!this.itemsListStockLocations) {
            this.rememberService.remember('selected.stocklocation_keyno_' + this.setting!.stockplace_id, event.item.item_id).then(() => {
                this.stateService.back();
            });
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'stockzone_keyno':
                this.loadStockLocations();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        
        return Promise.all([
            this.loadStockZones()
        ]).then(() => {
            this.loadStockLocations();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockplace_id: string;
    stockzone_keyno: string;
    filtervalue: string;
}

interface StockZoneItem {
    stockzone_keyno: string;
    stockzone_name: string;
    orderby: number;
}
